import { flow } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { parentSelector } from '../../selectors/parentSelector';
import { ApplicationState } from '../../types';

import { getEndDate, getStartDate } from '../resourceOrder/selectors';
import { getSellLimitHash } from './hash';

const getSellLimits = flow(parentSelector, (entities) => entities.data.sellLimits);

const getIntervalSellLimits = createSelector(
    getSellLimits,
    getStringProp('startDate'),
    getStringProp('endDate'),
    (sellLimitSlice, startDate, endDate) => {
        const hash = getSellLimitHash({ startDate, endDate });

        return sellLimitSlice?.[hash] ?? [];
    }
);

export const getCurrentSellLimits = (state: ApplicationState) => {
    const startDate = getStartDate(state);
    const endDate = getEndDate(state);
    if (startDate == null || endDate == null) {
        return [];
    }
    return getIntervalSellLimits(state, { startDate, endDate });
};
